import React, { Fragment, useEffect, useState } from 'react';
import Axios from 'axios';
import Notify from '../../notification/Notify';
import { TableContainer, Table, TableRow, TableCell, TableBody, TableHead, Box, TablePagination, Paper, TableFooter } from '@material-ui/core';

const Transaction = () => {
    const user_id = localStorage.getItem('user_id')
    const token = localStorage.getItem('token')
    const management_id = localStorage.getItem('management_id')
    const [transaction, setTransaction] = useState([])
    const [transactionRdy, setTransactionRdy] = useState([])
    const [totalCostt, setTotalCost] = useState(0)
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const getTransaction = () => {
        var params = {
            token: token,
            user_id: user_id,
            management_id: management_id,
        }
        Axios.get('patient/credits/credits-transaction', { params })
            .then((response) => {
                const data = response.data;
                setTransaction(data);
                setTransactionRdy(true);
                totalCost(data);
            }).catch(error => {
                Notify.requestError(error);
            });
    }

    const totalCost = (data) => {
        var total = 0;
        for (let index = 0; index < data.length; index++) {
            total += parseFloat(data[index].transaction_cost);
        }
        setTotalCost(total)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    useEffect(() => {
        getTransaction();
        //eslint-disable-next-line
    }, [])

    return (
        <>
            {transactionRdy && (
                <Fragment>  
                    <Box component={Paper} variant="outlined">
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center"> Date </TableCell>
                                        <TableCell align="center"> Trans# </TableCell>
                                        <TableCell align="center"> Ref# </TableCell>
                                        <TableCell align="center"> Transaction </TableCell>
                                        <TableCell align="center"> Status  </TableCell>
                                        <TableCell align="center"> Credit  </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {(rowsPerPage > 0
                                        ? transaction.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        : transaction
                                    ).map((data, index) => (
                                        <TableRow key={index}>
                                            <TableCell align="right"> {Notify.createdAt(data.created_at)}</TableCell>
                                            <TableCell align="right">{data.transaction_id.replace('transaction-', '')}</TableCell>
                                            <TableCell align="right">{data.reference_no}</TableCell>
                                            <TableCell align="left">{data.services}</TableCell>
                                            <TableCell align="center">{data.transaction_status}</TableCell>
                                            <TableCell align="right">{data.transaction_cost}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                                <TableFooter>
                                    <TableRow>
                                        <TableCell colSpan={4} />
                                        <TableCell align="center"> Total  </TableCell>
                                        <TableCell align="right"> { Notify.convertToNumber(totalCostt) }  </TableCell>
                                    </TableRow>
                                </TableFooter>
                            </Table>

                            <TablePagination
                                component={"div"}
                                rowsPerPageOptions={[5, 10, 25]}
                                count={transaction.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                            />
                        </TableContainer>
                    </Box>
                </Fragment>
            )}
        </>
    )
}

export default Transaction;